import PropTypes from "prop-types";
import "./styles.scss";

const StepLine = ({ complete }) => {
  return (
    <div
      className={complete ? "step-line l-complete" : "step-line l-pending"}
    />
  );
};

export default StepLine;

StepLine.propTypes = {
  complete: PropTypes.bool.isRequired
};
